import objectFitImages from 'object-fit-images';
import initHeader from './header';
import initPluses from './pluses';
import initEnvironment from './environment';
import initFilter from './filter';
// import initDeveloper from './developer';
import initFeedback from './feedback';
import initPopup from './popup';
import initForm from './form';
import initMap from './map';

objectFitImages();

export default () => {

  const $header = $('.header-l');
  if($header.length) {
    initHeader($header);
  }

  const $pluses = $('.pluses');
  if($pluses.length) {
    initPluses($pluses);
  }

  const environment = $('.environment');
  if(environment.length) {
    initEnvironment(environment);
  }

  const $filter = $('.filter');
  if($filter.length) {
    initFilter($filter);
  }

  // const $developer = $('.developer');
  // if($developer.length) {
  //   initDeveloper($developer);
  // }

  const $feedback = $('.feedback');
  if($feedback.length) {
    initFeedback($feedback);
  }

  const $popup = $('.popup');
  if($popup.length) {
    initPopup($popup);
  }

  const $form = $('.form');
  if($form.length) {
    initForm($form);
  }

  const $map = $('.map');
  if($map.length) {
    initMap($map);
  }

  function onAnchorScroll() {
    const $menu = $('.menu-l');
    let minusTop = $('window').width() > 991 ? 114 : 155;
    let delay = 0;
    $('.js-anchor-link').on('click', (e) => {
      if($menu.hasClass('menu-l--open')){
        delay = 400;
      }
      e.preventDefault();
      $menu.removeClass('menu-l--open');
      $('body').removeClass('no-scroll');
      const linkId = $(e.currentTarget).attr('href');
      let top = $(linkId).offset().top;
      setTimeout(() => {
        $('body,html').animate({scrollTop: top - minusTop}, 600);
      },delay);
      delay = 0
    })
  }
  onAnchorScroll();
}




// WEBPACK FOOTER //
// ./resources/assets/js/new-landing-constructor/index.js